//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import Translator from '@/services/translator'

//
import DispatchRequestBatchModel from '@/models/Warehouse/WhDispatchRequestBatch'
import fields from './fields'

//
export default {
    name: 'dispatch-requests-batch-create',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', ['user']),
        /**
         *
         */
        formProps() {
            return {
                fields,
            }
        },
    },
    data() {
        return {
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setAppToolbarTitle: 'setAppToolbarTitle',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
            setErrorSnackbar: 'setErrorSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
            setWarningSnackbar: 'setWarningSnackbar',
        }),

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'dispatch-request-batch' })
        },

        /**
         *
         */
        reset() {
            //
            this.formData = new DispatchRequestBatchModel()
            //
            this.formData.supervisor_g_user_id = this.user.id
        },

        /**
         *
         */
        showError(error) {
            this.setErrorSnackbar(
                Translator(DispatchRequestBatchModel, error.response.data)
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        showSuccess() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Lote de despacho agregado.',
                this.redirect
            )
        },

        /**
         *
         */
        submit() {
            return this.$refs.form
                .setWait(true)
                .then(this.toCreate)
                .finally(this.$refs.form.setWait)
                .then(this.showSuccess)
                .catch(this.showError)
        },

        /**
         *
         */
        toCreate(model) {
            return model.toCreate().save()
        },
    },
    beforeMount() {
        this.setAppToolbarTitle({ title: 'Crear lote de despacho' })
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_DISPATCH_REQUEST_BATCH'))
                ctx.$router.push('/')
        })
    },
}
